import { useContext, useCallback } from 'react';
import { useSelector } from '@xstate/react';

import { GlobalStateContext } from '../../../contexts';

import { subscriptionsSelectors } from '../../../machines';

export const useSubscriptions = () => {
  const { subscriptionsService } = useContext(GlobalStateContext);

  const { isLoading, error, ready } = useSelector(
    subscriptionsService,
    subscriptionsSelectors.getSubscriptionsFetchStatus
  );

  const initialize = useCallback(() => {
    if (error) subscriptionsService.send('RETRY_FETCH_SUBSCRIPTIONS');
    else subscriptionsService.send('FETCH_SUBSCRIPTIONS');
  }, [error]);

  return {
    isLoading,
    initialize,
    ready,
    error,
  };
};
